// extracted by mini-css-extract-plugin
export default {"statusContainer":"_3Ktkfhiha9b_0WwqKSIs8B","viewHeader":"I0jzcC4v2DsDa9tWo4vBD","typoDetailsHead":"_38ZKKPymhQ3n01JM4RM00F","fontBlue":"_3IdPpD7vVfW7eBA6at2vKg"};